var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGrayUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24074 0.8858L0.414964 5.34921C-0.141042 5.99788 0.319867 7 1.17422 7H8.82578C9.68013 7 10.141 5.99788 9.58504 5.34921L5.75926 0.885799C5.36016 0.420188 4.63984 0.420188 4.24074 0.8858Z",
    fill: "#D7DCE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGrayUp);
export default __webpack_public_path__ + "static/media/arrow-gray-up.ae5beb0ba7b931b7a675cadeafeea072.svg";
export { ForwardRef as ReactComponent };